import { classNames } from "utils/helper/helper";
import { Button, Spinner } from "@nextui-org/react";
import { BiCheck } from "react-icons/bi";

function AddButton({
  text = "Save Changes",
  loading = false,
}: {
  text?: string;
  loading?: boolean;
}) {
  const isLoading = loading;
  return (
    <Button
      color="secondary"
      type="submit"
      isLoading={isLoading}
      startContent={<BiCheck size={20} />}
    >
      {text}
    </Button>
  );
}

export default AddButton;
